_collow.components.ProfileMenu = class ProfileMenu extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  menuToggleBtn;
  screenSize;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;
    this.menuToggleBtn = this.root.querySelector(".menu-button");
    this.screenSize = window.innerWidth;

    window.addEventListener("_collow.current-user", () => this.handleMenuHiding());
    window.onload = this.setMenuDropdownEvent()
    window.onload = this.handleToggleMenu("loading")
    this.handleMenuHiding();
    
    this.menuToggleBtn.addEventListener("click", () => this.handleToggleMenu("button"))
  }

  /**
   * Hides the menu items based on the user role and the whitelabel contracted features
   */
  handleMenuHiding = () => {
    const linkMap = {
      users: '/admin',
      assessment: '/assessment-results',
      groups: '/group',
      analytics: '/admin/statistics',
      support: '/admin/supportform',
      migration: '/migrationtool'
    }
    let progressJson = JSON.parse(window.localStorage.getItem("progressJson"));
    let accesibleFeatures = JSON.parse(window.localStorage.getItem('whitelabelFeatures'));

    const manageCategory = this.root.querySelector('.dropdow-category:has([data-js="manage"])')
    const statisticsCategory = this.root.querySelector('.dropdow-category:has([data-js="statistics"])')
    
    // Handle assessment link separately — accessible to all with feature flag
    const assessmentLink = this.root.querySelector(`a[href="${linkMap.assessment}"]`);
    if (assessmentLink && accesibleFeatures?.has_assessment) {
      assessmentLink.removeAttribute('hidden');
    }

    if (progressJson?.role == 2) {
      const anchorTags = this.root.querySelectorAll("a");
      anchorTags.forEach(tag => {
        
        if (tag.getAttribute('href') === linkMap.users) {
          tag.removeAttribute('hidden');
          manageCategory.removeAttribute('hidden');

        } else if (tag.getAttribute('href') === linkMap.groups) {
          if (accesibleFeatures && accesibleFeatures?.has_user_groups)
            tag.removeAttribute('hidden');
            manageCategory.removeAttribute('hidden');

        } else if (tag.getAttribute('href') === linkMap.migration) {
          if (accesibleFeatures && accesibleFeatures?.has_content_migration_tool)
            tag.removeAttribute('hidden');
            manageCategory.removeAttribute('hidden');

        } else if (tag.getAttribute('href') === linkMap.analytics) {
          if (accesibleFeatures && accesibleFeatures?.has_dashboard)
            statisticsCategory.removeAttribute('hidden');
            tag.removeAttribute('hidden');

        } else if (tag.getAttribute('href') === linkMap.support) {
          if (accesibleFeatures && accesibleFeatures?.advanced_support)
            tag.removeAttribute('hidden');
        }
      });
    }
  };

  setMenuDropdownEvent = () => {
    const menuCategories = this.root.querySelectorAll(".dropdown-toggle");
    menuCategories.forEach(menuCategory => menuCategory.addEventListener("click", this.handleMenuDropdown))
  }

  handleMenuDropdown = (e) => {
    const clickedMenu = e.currentTarget.getAttribute("id")
    const menuCategory = document.querySelector(`[data-js="${clickedMenu}"]`)
    const arrowMenuCategory = menuCategory.querySelector("i")
    arrowMenuCategory.classList.toggle("fa-rotate-180")
    const expanded = menuCategory.getAttribute('aria-expanded') === 'true' || false;
    menuCategory.setAttribute('aria-expanded', !expanded);
  }

  handleToggleMenu = (origin) => {
    const menu = document.querySelector(".profile__menu")
    const menuArrowBtn = menu.querySelector("i")
    const studentDashboard = document.querySelector(".studentdashboard__structure");
    const adminDashboard = document.querySelector(".admindashboard-structure");
    const supportForm = document.querySelector(".support-form");
    const assessmentDashboard = document.querySelector(".assessmentdashboard__structure");
    const coursesAIDashboard = document.querySelector(".coursesaidashboard__structure");
    const migrationtoolDashboard = document.querySelector(".migrationtool__structure");
    const addUserDashboard = document.querySelector(".admin-add-user");
    
    if(this.screenSize <= 992 && origin === "loading") {
      menuArrowBtn.classList.remove("fa-chevron-left")
      menuArrowBtn.classList.add("fa-chevron-right")
      menu.classList.add("profile__menu--hidden")
      studentDashboard && studentDashboard.classList.add("studentdashboard__structure--expanded");
      adminDashboard && adminDashboard.classList.add("admindashboard-structure--expanded");
      supportForm && supportForm.classList.add("support-form--expanded");  
      assessmentDashboard && assessmentDashboard.classList.add("assessmentdashboard__structure--expanded");  
      coursesAIDashboard && coursesAIDashboard.classList.add("coursesaidashboard__structure--expanded");  
      migrationtoolDashboard && migrationtoolDashboard.classList.add("migrationtool__structure--expanded"); 
      addUserDashboard && addUserDashboard.classList.add("admin-add-user--expanded"); 
    } else if (origin === "button") {
      menuArrowBtn.classList.toggle("fa-chevron-left")
      menuArrowBtn.classList.toggle("fa-chevron-right")
      menu.classList.toggle("profile__menu--hidden")
      studentDashboard && studentDashboard.classList.toggle("studentdashboard__structure--expanded");
      adminDashboard && adminDashboard.classList.toggle("admindashboard-structure--expanded");
      supportForm && supportForm.classList.toggle("support-form--expanded");
      assessmentDashboard && assessmentDashboard.classList.toggle("assessmentdashboard__structure--expanded");
      coursesAIDashboard && coursesAIDashboard.classList.toggle("coursesaidashboard__structure--expanded");
      migrationtoolDashboard && migrationtoolDashboard.classList.toggle("migrationtool__structure--expanded"); 
      addUserDashboard && addUserDashboard.classList.toggle("admin-add-user--expanded"); 
    }

  }
};
